import { createClient } from "@supabase/supabase-js";
import type { Database } from "./database.types";

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  throw new Error(
    "Missing VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY. Copy .env.example to .env and fill it in.",
  );
}

export const supabase = createClient<Database>(url, anonKey, {
  auth: {
    // The magic link lands on the app with the session in the URL fragment.
    detectSessionInUrl: true,
    persistSession: true,
    autoRefreshToken: true,
    flowType: "pkce",
  },
  realtime: {
    // Four people. There is no reason to let this run hot.
    params: { eventsPerSecond: 5 },
  },
});

export const PROOF_PHOTOS_BUCKET = "proof-photos";
